import * as Preact from 'preact';
import * as CardGroup from './A_CardGroup';
import * as QuestionCard from './A_QuestionCard';
import ListItemButton from '@mui/material/ListItemButton';

/**
 * Figma design nodes:
 * Mobile: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9715%3A60134
 * Desktop: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9715%3A60633
 */

export type Props = {
    questions: Array<QuestionCard.Props>;
    onSelectQuestion: (question: string) => void;
    nullOptionText: string;
};

export const Component = (p: Props) => (
    <CardGroup.Component>
        {p.questions.map(q => (
            <ListItemButton
                onClick={() => p.onSelectQuestion(q.propertyName)}
                autoFocus={q.focus}
                sx={{ width: 'min-content', borderRadius: '8px', flexGrow: 0, padding: '0px' }}
                data-testId="question-btn"
            >
                <QuestionCard.Component {...q} nullOptionText={p.nullOptionText} />
            </ListItemButton>
        ))}
    </CardGroup.Component>
);
